import React, { createContext } from "react";
import { ITableContext, ITableContextData } from "../type/contextType/tkTableContextType";

export const TkTableContext = createContext<{
  tableContext: ITableContextData;
  setTableContext: (formContext: ITableContextData) => void;
}>({
  tableContext: {},
  setTableContext: (formContext: ITableContextData) => { },
});

export const TkTableContextProvider: React.FC<ITableContext> = (props) => {
  const [tableContext, setTableContext] = React.useState<ITableContextData>({});

  return (
    <TkTableContext.Provider value={{ tableContext, setTableContext }}>
      {props.children}
    </TkTableContext.Provider>
  );
};

export default TkTableContext;
